/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

const liveSearchFacetsOptions = {
    /**
     * Update facet options with disabled state
     *
     * @param {Object} facet - The facet to update.
     * @param {Array} facets - The array of facets to process.
     * @returns {Object} - The updated facet.
     */
    updateFacetOptions(facet, facets) {
        const currentFacet = this.findCurrentFacet(facet, facets);
        if (currentFacet) {
            this.updateOptionsBasedOnAttribute(facet, currentFacet);
        }
        return facet;
    },
    /**
     * Update options based on the attribute of the facet
     *
     * @param {Object} facet - The facet to update.
     * @param {Object} currentFacet - The current facet to compare against.
     */
    updateOptionsBasedOnAttribute(facet, currentFacet) {
        if (facet.attribute !== this.facetConfig.mergedBhAttribute) {
            this.disableUnavailableOptions(facet, currentFacet);
        } else {
            this.disableUnavailableBhSizeOptions(facet, currentFacet);
        }
    },
    /**
     * Disable unavailable options
     *
     * @param {Object} facet - The facet to update.
     * @param {Object} currentFacet - The current facet to compare against.
     */
    disableUnavailableOptions(facet, currentFacet) {
        // If there are no buckets, disable all options
        if (!currentFacet.buckets.length) {
            facet.options.forEach(option => {
                option.disabled = true;
            });
            return;
        }

        // Otherwise, disable options not matching an available bucket
        facet.options.forEach(option => {
            const isAvailable = currentFacet.buckets.some(
                bucket => bucket.title !== "no" && bucket.count > 0 && bucket.title === option.label
            );
            option.disabled = !isAvailable;
        });
    },
}

export default liveSearchFacetsOptions;
